import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {ISupply, VatTu} from '@entities/vat-tu/vat-tu.model';
import {VatTuService} from '@entities/vat-tu/vat-tu.service';
import {JhiEventManager, JhiAlertService} from 'ng-jhipster';
import {LoaiVatTuService} from '@entities/loai-vat-tu/loai-vat-tu.service';
import {ILoaiVatTu} from '@entities/loai-vat-tu/loai-vat-tu.model';
import {HttpResponse} from '@angular/common/http';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {DonViService} from '@entities/don-vi';
import {Principal} from '@app/core';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-vat-tu-dialog',
  templateUrl: './vat-tu-dialog.component.html',
})
export class VatTuDialogComponent implements OnInit, OnDestroy {
  vattu: VatTu;
  listLoaiVatTu: ILoaiVatTu[];
  listSupply: ISupply[];
  listUnit$: any;
  isSaving: boolean;
  customerId = null;
  customerData: any = [];
  private unsubscribeAll = new Subject();
  constructor(
    private dialogRef: MatDialogRef<VatTuDialogComponent>,
    private vattuService: VatTuService,
    private eventManager: JhiEventManager,
    private titleService: Title,
    private principal: Principal,
    private translate: TranslateService,
  ) {
    this.isSaving = false;
    this.vattu = new VatTu();
    this.listLoaiVatTu = [];
    this.listSupply = [];
    this.listUnit$ = [];
  }

  ngOnInit() {
    this.principal
      .getAuthenticationState()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((user) => {
        if (user) {
          this.customerId = user.customerId;
          if (user.customerId) {
            this.vattu.tbCustomerId =
              this.vattu.tbCustomerId || user.customerId;
          }
        }
      });
    this.vattuService.supplyType().subscribe((res: any) => {
      this.listSupply = res.body ? res.body : [];
    });
    if (this.vattu.id !== null) {
      this.titleService.setTitle(
        this.translate.instant(
          'entities.vat-tu.vat-tu-dialog.Sửa vật tư_title',
        ),
      );
    } else {
      this.titleService.setTitle(
        this.translate.instant(
          'entities.vat-tu.vat-tu-dialog.Thêm vật tư_title',
        ),
      );
    }
  }

  save() {
    this.isSaving = true;
    if (this.vattu.id !== null) {
      this.vattuService.update(this.vattu).subscribe(
        (response) => {
          this.onSaveSuccess(response);
        },
        () => this.onSaveError(),
      );
    } else {
      this.vattuService.create(this.vattu).subscribe(
        (response) => this.onSaveSuccess(response),
        () => this.onSaveError(),
      );
    }
  }

  private onSaveSuccess(result) {
    this.isSaving = false;
    this.eventManager.broadcast({
      name: 'vattuListModification',
      content: 'VatTu',
    });
    this.dialogRef.close(true);
  }

  private onSaveError() {
    this.isSaving = false;
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next('');
    this.unsubscribeAll.complete();
  }
}

@Component({
  selector: 'app-vat-tu-popup',
  template: '',
})
export class VatTuPopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<VatTuDialogComponent>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private alertService: JhiAlertService,
    private titleService: Title,
    private vatTuService: VatTuService,
    private donViService: DonViService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.activatedRouteVatTu();
  }

  ngOnDestroy() {
    this.dialogRef = null;
    this.titleService.setTitle(
      this.translate.instant(
        'entities.vat-tu.vat-tu-dialog.Danh sách vật tư_title',
      ),
    );
  }

  activatedRouteVatTu() {
    this.activatedRoute.data.subscribe(({vattu}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(VatTuDialogComponent, {
          disableClose: true,
          width: '380px',
        });
        if (vattu) {
          this.dialogRef.componentInstance.vattu = vattu;
        }
        this.vatTuService.listUnit().subscribe((res: any) => {
          this.dialogRef.componentInstance.listUnit$ = res;
        });
        this.donViService.dropdown().subscribe((data: any) => {
          this.dialogRef.componentInstance.customerData = data.body;
        });

        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }
}
